{
  "list": {
    "title": "الشركاء والعقود",
    "subtitle": "الشركاء وعقودهم",
    "new": "شريك جديد",
    "filterLabel": "تصفية الشركاء",
    "all": "الكل",
    "inactive": "متوقف",
    "empty": "لا يوجد شركاء",
    "activeContracts": "العقود السارية",
    "bookingsThisMonth": "حجوزات هذا الشهر",
    "noActiveContract": "لا يوجد عقد ساري",
    "expiresIn": "ينتهي العقد خلال {{n}} يوماً",
    "expiresOn": "ينتهي العقد {{date}}",
    "noEndDate": "عقد ساري بدون تاريخ انتهاء",
    "newDialogTitle": "شريك جديد",
    "inContract": "في العقد"
  },
  "form": {
    "name": "الاسم",
    "nameRequired": "الاسم مطلوب",
    "type": "النوع",
    "typeRequired": "اختر نوع الشريك",
    "typePlaceholder": "اختر النوع",
    "inactiveOption": "{{name}} (موقوف)",
    "crNumber": "السجل التجاري",
    "contactFirstName": "جهة التواصل — الاسم الأول",
    "contactLastName": "جهة التواصل — اسم العائلة",
    "phone": "الجوال",
    "email": "البريد",
    "save": "حفظ البيانات",
    "add": "إضافة الشريك",
    "saved": "تم حفظ البيانات",
    "added": "تمت إضافة الشريك",
    "saveFailed": "تعذر الحفظ",
    "inContract": "إدراج المنصة في عقد المنسقين (الملحق ب)",
    "inContractHint": "عند الحفظ يُرسل ملحق إضافي لكل المنسقين الذين لديهم عقد ليوقّعوه إلكترونياً، وتظهر المنصة في العقود الجديدة.",
    "inContractHintExisting": "إلغاء الإدراج يؤثر على العقود الجديدة فقط؛ العقود والملاحق الموقّعة تبقى كما هي.",
    "annexSent": "سيُرسل ملحق إضافي للمنسقين للتوقيع"
  },
  "detail": {
    "edit": "تعديل البيانات",
    "expiringBanner": "ينتهي عقد «{{title}}» في {{date}}. جدّد العقد مع الشريك.",
    "contracts": "العقود",
    "noContracts": "لا توجد عقود مرفوعة.",
    "contractMeta": "{{start}} – {{end}} · {{size}} · رفعه {{by}}",
    "editDialogTitle": "تعديل الشريك"
  },
  "upload": {
    "title": "رفع عقد جديد",
    "contractTitle": "عنوان العقد",
    "start": "يبدأ",
    "end": "ينتهي",
    "endBeforeStart": "يجب أن يكون بعد تاريخ البداية",
    "storedInDb": "يُحفظ داخل قاعدة البيانات",
    "progress": "تقدم الرفع",
    "submit": "رفع العقد",
    "uploaded": "تم رفع العقد",
    "failed": "تعذر رفع العقد"
  },
  "info": {
    "title": "بيانات الشريك",
    "type": "النوع",
    "crNumber": "السجل التجاري",
    "contact": "جهة التواصل",
    "phone": "الجوال",
    "email": "البريد",
    "bookingsThisMonth": "حجوزات هذا الشهر"
  },
  "toggle": {
    "deactivate": "إيقاف الشريك",
    "activate": "تفعيل الشريك",
    "deactivated": "تم إيقاف الشريك",
    "activated": "تم تفعيل الشريك"
  }
}
